import { render, staticRenderFns } from "./SelectOrderType.vue?vue&type=template&id=71bb5664&scoped=true&"
import script from "./SelectOrderType.vue?vue&type=script&lang=js&"
export * from "./SelectOrderType.vue?vue&type=script&lang=js&"
import style0 from "./SelectOrderType.vue?vue&type=style&index=0&id=71bb5664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb5664",
  null
  
)

export default component.exports